import { Controller } from "@hotwired/stimulus"

// Sends mobile visitors straight to their platform's store listing. Desktop
// visitors keep the page and see both badges. The delay lets the page paint
// first, so a returning visitor sees where they were sent.
//
//   div data-controller="apps-redirect"
//     data-apps-redirect-ios-value="https://apps.apple.com/app/id..."
//     data-apps-redirect-android-value="https://play.google.com/..."
export default class extends Controller {
  static values = {
    ios: String,
    android: String,
    delay: { type: Number, default: 500 }
  }

  connect() {
    const url = this.storeUrl
    if (!url) return

    this.timeout = setTimeout(() => {
      window.location = url
    }, this.delayValue)
  }

  disconnect() {
    clearTimeout(this.timeout)
  }

  // An unset Stimulus String value is "", not undefined — so fall through to
  // null rather than navigating to the current page.
  get storeUrl() {
    const userAgent = navigator.userAgent

    if (userAgent.includes("Android")) return this.androidValue || null
    if (userAgent.includes("iPhone OS")) return this.iosValue || null

    return null
  }
}
